import request from "@/utils/request";

//登录
export function login(data) {
  return request({
    url: "/web/user/login",
    method: "post",
    data,
  });
}
//注册
export function register(data) {
  return request({
    url: "/web/user/register",
    method: "post",
    data,
  });
}
//发送短信
export function sendRegSms(data) {
  return request({
    url: "/web/user/sendRegSms",
    method: "post",
    data,
  });
}
//发送找回短信
export function sendFindSms(data) {
  return request({
    url: "/web/user/sendFindSms",
    method: "post",
    data,
  });
}
//修改密码
export function restPass(data) {
  return request({
    url: "/web/user/restPass",
    method: "post",
    data,
  });
}
//用户找回
export function findUser(data) {
  return request({
    url: "/web/user/findUser",
    method: "post",
    data,
  });
}
//身份认证
export function shenfenzhzeng(data) {
  return request({
    url: "/web/user/shenfenzhzeng",
    method: "post",
    data,
  });
}
//创建订单
export function createOrder(data) {
  return request({
    url: "/web/order",
    method: "post",
    data,
  });
}
//收藏列表
export function collectList(params) {
  return request({
    url: "/web/collect/list",
    method: "get",
    params,
  });
}
//收藏ids

export function getCollectIds(params) {
  return request({
    url: "/web/collect",
    method: "get",
    params,
  });
}
//我的订单

export function getOrderList(params) {
  return request({
    url: "/web/order/list",
    method: "get",
    params,
  });
}
//发票
export function invoiceList(params) {
  return request({
    url: "/web/invoice/list",
    method: "get",
    params,
  });
}
//申请面授
export function getOfflineList(params) {
  return request({
    url: "/web/offline/list",
    method: "get",
    params,
  });
}
//我的课程
export function myCourseList(params) {
  return request({
    url: "/web/us/list",
    method: "get",
    params,
  });
}
//我的课程详情
export function myCourseDetails(ucId) {
  return request({
    url: `/web/us/detail/${ucId}`,
    method: "get",

  });
}
//观看视频
export function viewVedio(data) {
  return request({
    url: "/web/us/l",
    method: "post",
    data,
  });
}

//学习证明
export function getProveList(params) {
  return request({
    url: "/web/prove/list",
    method: "get",
    params,
  });
}
//下载学习证明
export function downloadProve(proveId) {
  return request({
    url: `/web/prove/${proveId}`,
    method: "get",
    responseType: 'blob'

  });
}
//申请发票
export function invoice(data) {
  return request({
    url: "/web/invoice",
    method: "post",
    data,
  });
}
//收藏
export function collect(data) {
  return request({
    url: "/web/collect",
    method: "post",
    data,
  });
}
//取消收藏
export function cancelCollect(data) {
  return request({
    url: "/web/collect",
    method: "post",
    data,
  });
}
//视频播放
export function courseOpen(data) {
  return request({
    url: "/web/us/l",
    method: "post",
    data,
  });
}
//获取用户信息

export function getUserInfo(params) {
  return request({
    url: "/web/user/info",
    method: "get",
    params,
  });
}
//获取新闻列表
export function getNewsList(params) {
  return request({
    url: "/web/notice/list",
    method: "get",
    params,
  });
}
//新闻详情
export function getCourseDetails(id) {
  return request({
    url: `/web/course/${id}`,
    method: "get",
  });
}
//课程详情
export function getNesDetails(id) {
  return request({
    url: `/web/notice/${id}`,
    method: "get",
  });
}

//字典查询
// 课程类型 ej_course_type
// 专业目录 ej_course_major
// 订单类型 ej_order_type
// 支付状态 ej_order_state
export function getType(id) {
  return request({
    url: `/web/dict/data/type/${id}`,
    method: "get",
  });
}
//首页课程列表
export function getCourseList(params) {
  return request({
    url: "/web/course/list",
    method: "get",
    params,
  });
}
//获取验证图片
// export function reqGet(data) {
//     return request({
//         url: '/captcha/get',
//         method: 'post',
//         data
//     })
// }

//滑动或者点选验证
// export function reqCheck(data) {
//     return request({
//         url: '/captcha/check',
//         method: 'post',
//         data
//     })
// }
